const no_internet_connexion = {
  title: 'Connexion lost',
  subtitle: 'Please check your internet connection and try again',
  retry: 'Retry',
}

export default no_internet_connexion
